import { createContext, useContext, useState, useMemo } from 'react';

const AppModeContext = createContext(null);

export function AppModeProvider({ children }) {
  const [isMobileDevice] = useState(() => window.innerWidth <= 1024);

  const [appMode, setAppModeState] = useState(() => {
    return localStorage.getItem('appMode') || null;
  });

  const setAppMode = (mode) => {
    localStorage.setItem('appMode', mode);
    setAppModeState(mode);
  };

  const clearAppMode = () => {
    localStorage.removeItem('appMode');
    setAppModeState(null);
  };

  const needsModeSelection = useMemo(
    () => isMobileDevice && !appMode,
    [isMobileDevice, appMode]
  );

  const isDataEntryMode = useMemo(
    () => isMobileDevice && appMode === 'dataEntry',
    [isMobileDevice, appMode]
  );

  return (
    <AppModeContext.Provider value={{
      isMobileDevice, appMode, setAppMode, clearAppMode,
      needsModeSelection, isDataEntryMode,
    }}>
      {children}
    </AppModeContext.Provider>
  );
}

export function useAppMode() {
  const ctx = useContext(AppModeContext);
  if (!ctx) throw new Error('useAppMode must be used within AppModeProvider');
  return ctx;
}
